import {GameOptions, QuestionResponse} from "../state/state";
import {QuestionDefinition} from "../state/questions";

export enum TriviaAction {
    Begin = "begin",
    Reset = "reset",
    Respond = "respond",
    Advance = "advance",
    End = "end",
    Pause = "pause",
    Options = "options",
    ChangeQuestions = "change-questions",
    DownloadResults = "download-results",
    Chat = "chat",
    ReadChat = "read-chat"
}

interface BaseMessage {
    type: TriviaAction
}

interface BeginMessage extends BaseMessage {
    type: TriviaAction.Begin
}

interface AdvanceMessage extends BaseMessage {
    type: TriviaAction.Advance
}

interface ResetMessage extends BaseMessage {
    type: TriviaAction.Reset
}

interface PauseMessage extends BaseMessage {
    type: TriviaAction.Pause
}

export interface ResponseMessage extends BaseMessage {
    type: TriviaAction.Respond
    data: QuestionResponse
}

export interface OptionsMessage extends BaseMessage {
    type: TriviaAction.Options
    gameOptions: GameOptions
}

export interface ChangeQuestionsMessage extends BaseMessage {
    type: TriviaAction.ChangeQuestions
    questions: QuestionDefinition[]
}

interface DownloadResultsMessage extends BaseMessage {
    type: TriviaAction.DownloadResults
}

export interface ChatMessage extends BaseMessage {
    type: TriviaAction.Chat
    text: string
}

export interface ReadChatMessage extends BaseMessage {
    type: TriviaAction.ReadChat
    count: number
}

export type TriviaMessage = ResponseMessage | ResetMessage | BeginMessage | AdvanceMessage |
    PauseMessage | OptionsMessage | ChangeQuestionsMessage | DownloadResultsMessage | ChatMessage | ReadChatMessage;